module.exports = __webpack_public_path__ + "img/default-banner.90678026.jpg";